import { prompt, type PromptDefinition } from './models';

export const BUILDING_SURVEYOR_PROMPTS = [
    prompt(
        'Meet obligations',
        'Which statutory approvals and inspection records are available for this building?',
        'Which buildings lack statutory approval or inspection records for survey review?'
    ),
    prompt(
        'Meet obligations',
        'What does the occupancy documentation permit for this building?',
        'Which buildings have occupancy documentation that needs clarification?'
    ),
    prompt(
        'Meet obligations',
        'What non-compliances are recorded in survey reports for this building?',
        'Which buildings have unresolved survey-reported non-compliances?'
    ),
    prompt(
        'Meet obligations',
        'Find building survey reports for this building relating to…',
        'Find building survey reports across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Plan change',
        "Where do this building's approved plans and recorded existing conditions differ?",
        'Which buildings have discrepancies between approved plans and recorded conditions?'
    ),
    prompt(
        'Manage risk',
        'What essential safety measures are specified for this building in its records?',
        'Which buildings have incomplete essential-safety-measure specifications in their records?'
    ),
    prompt(
        'Meet obligations',
        'What evidence addresses outstanding building orders for this building?',
        'Which buildings have outstanding building orders without rectification evidence?'
    ),
    prompt(
        'Meet obligations',
        'Find statutory inspection evidence for this building concerning…',
        'Find statutory inspection evidence across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        'Which alterations to this building lack supporting approval records?',
        'Which buildings have alterations without supporting approval evidence?'
    ),
    prompt(
        'Meet obligations',
        "What supporting certificates are missing from this building's survey file?",
        "Compare missing certificates across my buildings' survey files."
    ),
    prompt(
        'Meet obligations',
        'Which findings require further site verification for this building?',
        'Which buildings have survey findings requiring further site verification?'
    ),
    prompt(
        'Meet obligations',
        "Prepare a statutory evidence checklist for this building's…",
        'Compare statutory evidence across my buildings for…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
